// extracted by mini-css-extract-plugin
export default {"backgroundAudio":"backgroundAudio_backgroundAudio__fwwRH","hide":"backgroundAudio_hide__K+1B1"};